/**
 * Created by slava on 23.03.17.
 */

cleverapps.WordPerlineGrid = cc.Node.extend({
    avoidNode: "BoardView",
    ctor: function (field) {
        this._super();
        this.setAnchorPoint(0.5, 0.5);
        this.createGrid(field);
        this.placeholderSize = new cc.Sprite(bundles.game.frames.placeholder_png).getContentSize();
    },

    createGrid: function (field) {
        const layerNodes = [];
        [cleverapps.Board.PLACEHOLDER_LAYER, cleverapps.Board.LETTER_LAYER, cleverapps.Board.ANIMATION_LAYER].forEach((layer) => {
            const layerNode = new cc.Node();
            layerNodes[layer] = layerNode;
            this.addChild(layerNode, layer);
        });

        this.letters = [];
        this.animations = [];
        this.placeholders = field.map((word, row) => word.split("").map((letter, col) => {
            const placeholder = new cc.Sprite(bundles.game.frames.placeholder_png);
            layerNodes[cleverapps.Board.PLACEHOLDER_LAYER].addChild(placeholder);

            if (cleverapps.config.debugMode) {
                cleverapps.UI.onClick(placeholder, () => {
                    Game.currentGame.hintBooster.addHint({ row, column: col });
                });
            }

            [cleverapps.Board.LETTER_LAYER, cleverapps.Board.ANIMATION_LAYER].forEach((layer) => {
                const layerPlaceholder = new cc.Node();
                layerPlaceholder.setContentSize(placeholder.width, placeholder.height);
                layerPlaceholder.layer = `layer_${layer}`;
                layerPlaceholder.setAnchorPoint(0.5, 0.5);

                const container = layer === cleverapps.Board.LETTER_LAYER ? this.letters : this.animations;
                if (!container[row]) {
                    container[row] = [];
                }
                container[row][col] = layerPlaceholder;
                layerNodes[layer].addChild(layerPlaceholder);
            });

            return placeholder;
        }));

        this.layers = [this.placeholders, this.letters, this.animations];
    },

    updatePlaceholders: function (columns) {
        const size = this.calcColumnsSize(columns, (placeholder, x, y) => {
            placeholder.setPosition(x + this.placeholderSize.width / 2, y + this.placeholderSize.height / 2);
        });

        this.layers.forEach((layer, layerIndex) => {
            layer.forEach((row, i) => {
                row.forEach((placeholder, j) => {
                    if (layerIndex === cleverapps.Board.PLACEHOLDER_LAYER) {
                        placeholder.y = size.height - placeholder.y;
                    } else {
                        placeholder.setPosition(this.placeholders[i][j].getPosition());
                    }
                });
            });
        });

        this.setContentSize(size);
    },

    updateGrid: function (availableRect) {
        if (this.manualUpdateGrid) {
            return;
        }
        const columns = this.calculateColumns(availableRect);
        this.updatePlaceholders(columns);
    },

    setColumnsAmount: function (amountColumns) {
        this.manualUpdateGrid = true;

        const columns = this.divideByColumn(amountColumns);
        this.updatePlaceholders(columns);
    },

    calculateColumns: function (availableRect) {
        let optimalColumns = [];
        let maxScale = 0;

        for (let amountColumns = 1; amountColumns <= this.placeholders.length; amountColumns++) {
            const columns = this.divideByColumn(amountColumns);
            const size = this.calcColumnsSize(columns);

            const scale = Math.min(availableRect.width / size.width, availableRect.height / size.height);
            if (scale > maxScale) {
                optimalColumns = columns;
                maxScale = scale;
            }
        }

        return optimalColumns;
    },

    divideByColumn: function (amount) {
        let first = 0;
        let columnLength = 0;
        const columns = [];

        for (let i = 0; i < amount; i++) {
            columnLength = Math.floor(this.placeholders.length / amount);
            if (i < this.placeholders.length % amount) {
                columnLength++;
            }
            columns.push(this.placeholders.slice(first, first + columnLength));
            first += columnLength;
        }

        return columns;
    },

    calcColumnsSize: function (columns, iterator) {
        const styles = cleverapps.styles.BoardView;

        iterator = iterator || function () {};

        const letterOffset = styles.Letter.offset;
        const columnOffset = styles.minSpaceX;
        const rowOffset = styles.minSpaceY;

        let sizeX = 0;
        let sizeY = 0;

        columns.forEach((column, k) => {
            let columnWidth = 0;
            let columnHeight = 0;

            for (let i = 0; i < column.length; i++) {
                const word = column[i];

                let wordWidth = 0;

                for (let j = 0; j < word.length; j++) {
                    iterator(word[j], sizeX + wordWidth, columnHeight);

                    wordWidth += this.placeholderSize.width + (j === word.length - 1 ? 0 : letterOffset);
                }

                columnWidth = Math.max(columnWidth, wordWidth);
                columnHeight += this.placeholderSize.height + (i === column.length - 1 ? 0 : rowOffset);
            }

            sizeX += columnWidth + (k === columns.length - 1 ? 0 : columnOffset);
            sizeY = Math.max(sizeY, columnHeight);
        });

        return cc.size(sizeX, sizeY);
    },

    getCell: function (row, col, layer) {
        layer = layer || cleverapps.Board.PLACEHOLDER_LAYER;

        return this.layers[layer][row][col];
    },

    putInCell: function (row, col, item, zOrder, layer) {
        layer = layer || cleverapps.Board.PLACEHOLDER_LAYER;

        const cell = this.layers[layer][row][col];
        cell.addChild(item, zOrder);
        item.setPosition(cell.width / 2, cell.height / 2);
    },

    isExistsCell: function (row, col) {
        return this.placeholders[row] && this.placeholders[row][col];
    },

    listCells: function (layer) {
        const activePlaceholders = [];
        for (let i = 0; i < this.placeholders.length; i++) {
            for (let j = 0; j < this.placeholders[i].length; j++) {
                switch (layer) {
                    case cleverapps.Board.PLACEHOLDER_LAYER:
                        activePlaceholders.push(this.placeholders[i][j]);
                        break;
                    case cleverapps.Board.LETTER_LAYER:
                        activePlaceholders.push(this.letters[i][j]);
                        break;
                    case cleverapps.Board.ANIMATION_LAYER:
                        activePlaceholders.push(this.animations[i][j]);
                        break;
                    default:
                        activePlaceholders.push(this.placeholders[i][j]);
                        activePlaceholders.push(this.letters[i][j]);
                        activePlaceholders.push(this.animations[i][j]);
                        break;
                }
            }
        }

        return activePlaceholders;
    },

    getColumn: function (index, layer) {
        layer = layer || cleverapps.Board.PLACEHOLDER_LAYER;

        return this.layers[layer][index];
    }
});